import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import dayjs from "dayjs";
import { Table, TableCell, TableContainer, TableRow, TableHead, TableBody, FormControl, RadioGroup, FormControlLabel, Radio, Button, Box, CircularProgress } from '@mui/material';
import { getReportCountMntTaskGroupByCtgr234AndEquipmentPartAndMntTypeByQuery, getReportCountMntTaskGroupByCtgr234AndMfCpnyNmAndMntTypeByQuery, getReportCountMntTaskGroupByCtgr234AndPositionAndMntTypeByQuery, getReportCountMntTaskGroupByCtgr234AndPositionAndRecordTypeByQuery, getReportCountMntTaskGroupByCtgr23AndSubwayLineByQuery, getReportCountMntTaskGroupByCtgr3ByQuery,  getReportCountQuarterlyMntTaskGroupByCtgr23ForTwoYearsByQuery, getReportCountYearlyMntTaskGroupByCtgr23ForTwoYearsByQuery } from "components/axios/reportAxios";
import PieChart from "components/inner/chart/PieChart";
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import { useEnumApi } from "contexts/EnumApiContext";
import CommonExcelDownload from "components/CommonExcelDownload";
import InDecreaseExcelDownload from "components/InDecreaseExcelDownload";
import BarChart from "components/inner/chart/BarChart";
import { orderNumber, reverseOrderNumber } from "data/data";
import CustomReportSelect2 from "components/select/CustomReportSelect2";
import CustomReportSelect from "components/select/CustomReportSelect";
import { DataGridPro } from "@mui/x-data-grid-pro";
import CustomEnumSelect from "components/select/CustomEnumSelect";

const EquipmentReportReportDataroomMaintenenceReport = () => {
    const { t } = useTranslation();

    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');

    const handleAlertClick = () => {
        openModal(modals.alertModal, {
            onClose : () => {
               // console.log(1111);
            },
            message: alertMessage,
        });
    };

    const { equipmentCategoryLevel1s, getEnumValueByEnumName } = useEnumApi();
    
    const today = dayjs(new Date()).format('YYYY-MM-DD');
    const subwayLines = getEnumValueByEnumName("SubwayLine");
    const maintenanceTypes = getEnumValueByEnumName("MaintenanceType");
    const maintenanceRecordTypes = getEnumValueByEnumName("MaintenanceRecordType");

    const [searchStartDateText, setSearchStartDateText] = useState(today);
    const [searchEndDateText, setSearchEndDateText] = useState(today);

    const [reportPeriodParam, setReportPeriodParam] = useState({});
    const [reportSubwayParam, setReportSubwayParam] = useState({});
    const [reportLevel1Param, setReportLevel1Param] = useState({});

    const [reportPeriod, setReportPeriod] = useState(null);
    const [reportSubway, setReportSubway] = useState(null);
    const [reportLevel1, setReportLevel1] = useState(null);

    const curYear = dayjs(new Date()).format("YYYY");
    const reportPeriodParams = [{code:"cy", title:t('message.common.select.current.year')},{code:"cy1", title:t('message.common.select.current.year.first.quarter')},{code:"cy2", title:t('message.common.select.current.year.second.quarter')},{code:"cy3", title:t('message.common.select.current.year.third.quarter')},{code:"cy4", title:t('message.common.select.current.year.fourth.quarter')},
    {code:"oy", title:t('message.common.select.last.year')},{code:"oy1", title:t('message.common.select.last.year.first.quarter')},{code:"oy2", title:t('message.common.select.last.year.second.quarter')},{code:"oy3", title:t('message.common.select.last.year.third.quarter')},{code:"oy4", title:t('message.common.select.last.year.fourth.quarter')}];
    const [pieDatas, setPieDatas] = useState([]);
    const [barData, setBarData] = useState(null);

    const [reportTitle, setReportTitle] = useState("");

    const [fileName, setFileName] = useState("");
    const [reports, setReports] = useState([]);
    const [excelDatas, setExcelDatas] = useState([]);
    const excelTopHeaders = [t('message.common.subtitle.level2'), t('message.common.subtitle.level3'), t('message.common.subtitle.total.count'), t('message.common.subtitle.one.subwayline'), t('message.common.subtitle.two.subwayline')];

    const [fileName2, setFileName2] = useState("");
    const [report2s, setReport2s] = useState([]);
    const [excelData2s, setExcelData2s] = useState([]);
    const [excelTopHeader2s, setExcelTopHeader2s] = useState([]);
    const [excelTopHeader22s, setExcelTopHeader22s] = useState([]);

    const [fileName3, setFileName3] = useState("");
    const [report3s, setReport3s] = useState([]);
    const [excelData3s, setExcelData3s] = useState([]);
    const [excelTopHeader3s, setExcelTopHeader3s] = useState([]);
    
    const [fileName4, setFileName4] = useState("");
    const [report4s, setReport4s] = useState([]);
    const [excelData4s, setExcelData4s] = useState([]);
    const [excelTopHeader4s, setExcelTopHeader4s] = useState([]);

    const [fileName5, setFileName5] = useState("");
    const [report5s, setReport5s] = useState([]);
    const [excelData5s, setExcelData5s] = useState([]);
    const [excelTopHeader5s, setExcelTopHeader5s] = useState([]);
    
    const [fileName6, setFileName6] = useState("");
    const [report6s, setReport6s] = useState([]);
    const [excelData6s, setExcelData6s] = useState([]);
    const [excelTopHeader6s, setExcelTopHeader6s] = useState([]);

    const [rows1, setRows1] = useState([]);
    const [rows2, setRows2] = useState([]);
    const [rows3, setRows3] = useState([]);
    const [rows4, setRows4] = useState([]);

    const columns1 = [
        { field: 'level2', headerName: t('message.common.subtitle.level2'), sortable: true, width: 150
          , valueGetter:(params)=>params.row?.level2
        },
        { field: 'level3', headerName: t('message.common.subtitle.level3'), sortable: true, width: 200
          , valueGetter:(params)=>params.row?.level3
        },
        { field: 'level4', headerName: t('message.common.select.component.part'), sortable:true, width: 200
          , valueGetter:(params)=>params.row?.level4
        },
        { field: 'location', headerName: t('message.common.subtitle.position'), sortable:true, width: 150
          , valueGetter:(params)=>params.row?.location
        },
        { field: 'sum', headerName: t('message.common.subtitle.total.count'), sortable:true, width: 120
          , valueGetter:(params)=>params.row?.sum
        },
        { field: 'type1', headerName: t('message.common.subtitle.maintenance.adjustment'), sortable:true, width: 120
          , valueGetter:(params)=>params.row?.type1
        },
        { field: 'type2', headerName: t('message.common.subtitle.maintenance.replacement'), sortable:true, width: 120
          , valueGetter:(params)=>params.row?.type2
        },
        { field: 'type3', headerName: t('message.common.subtitle.simple.failure'), sortable:true, width: 120
          , valueGetter:(params)=>params.row?.type3
        },
        { field: 'type4', headerName: t('message.common.subtitle.etc'), sortable:true, width: 120
          , valueGetter:(params)=>params.row?.type4
        }
    ];

    const columns2 = [
        { field: 'level2', headerName: t('message.common.subtitle.level2'), sortable: true, width: 150
          , valueGetter:(params)=>params.row?.level2
        },
        { field: 'level3', headerName: t('message.common.subtitle.level3'), sortable: true, width: 200
          , valueGetter:(params)=>params.row?.level3
        },
        { field: 'level4', headerName: t('message.common.select.component.part'), sortable:true, width: 200
          , valueGetter:(params)=>params.row?.level4
        },
        { field: 'location', headerName: t('message.common.subtitle.position'), sortable:true, width: 150
          , valueGetter:(params)=>params.row?.location
        },
        { field: 'sum', headerName: t('message.common.subtitle.total.count'), sortable:true, width: 120
          , valueGetter:(params)=>params.row?.sum
        },
        { field: 'type1', headerName: t('message.common.title.maintenance'), sortable:true, width: 120
          , valueGetter:(params)=>params.row?.type1
        },
        { field: 'type2', headerName: t('message.common.subtitle.breakdown.dysfunctions'), sortable:true, width: 120
          , valueGetter:(params)=>params.row?.type2
        }
    ];

    const columns3 = [
        { field: 'level2', headerName: t('message.common.subtitle.level2'), sortable: true, width: 150
          , valueGetter:(params)=>params.row?.level2
        },
        { field: 'level3', headerName: t('message.common.subtitle.level3'), sortable: true, width: 200
          , valueGetter:(params)=>params.row?.level3
        },
        { field: 'level4', headerName: t('message.common.select.component.part'), sortable:true, width: 200
          , valueGetter:(params)=>params.row?.level4
        },
        { field: 'madeby', headerName: t('message.common.subtitle.manufacturer'), sortable:true, width: 150
          , valueGetter:(params)=>params.row?.madeby
        },
        { field: 'type1', headerName: t('message.common.subtitle.maintenance.adjustment'), sortable:true, width: 120
          , valueGetter:(params)=>params.row?.type1
        },
        { field: 'type2', headerName: t('message.common.subtitle.maintenance.replacement'), sortable:true, width: 120
          , valueGetter:(params)=>params.row?.type2
        },
        { field: 'type3', headerName: t('message.common.subtitle.simple.failure'), sortable:true, width: 120
          , valueGetter:(params)=>params.row?.type3
        },
        { field: 'type4', headerName: t('message.common.subtitle.etc'), sortable:true, width: 120
          , valueGetter:(params)=>params.row?.type4
        }
    ];

    const columns4 = [
        { field: 'level2', headerName: t('message.common.subtitle.level2'), sortable: true, width: 150
          , valueGetter:(params)=>params.row?.level2
        },
        { field: 'level3', headerName: t('message.common.subtitle.level3'), sortable: true, width: 200
          , valueGetter:(params)=>params.row?.level3
        },
        { field: 'level4', headerName: t('message.common.select.component.part'), sortable:true, width: 200
          , valueGetter:(params)=>params.row?.level4
        },
        { field: 'location', headerName: t('message.common.subtitle.position'), sortable:true, width: 150
          , valueGetter:(params)=>params.row?.location
        },
        { field: 'part', headerName: t('message.common.subtitle.material'), sortable:true, width: 120
          , valueGetter:(params)=>params.row?.part
        },
        { field: 'type1', headerName: t('message.common.subtitle.maintenance.adjustment'), sortable:true, width: 120
          , valueGetter:(params)=>params.row?.type1
        },
        { field: 'type2', headerName: t('message.common.subtitle.maintenance.replacement'), sortable:true, width: 120
          , valueGetter:(params)=>params.row?.type2
        },
        { field: 'type3', headerName: t('message.common.subtitle.simple.failure'), sortable:true, width: 120
          , valueGetter:(params)=>params.row?.type3
        },
        { field: 'type4', headerName: t('message.common.subtitle.etc'), sortable:true, width: 120
          , valueGetter:(params)=>params.row?.type4
        }
    ];

    const [isLoading, setIsLoading] = useState(false);

    const selectParam = (e) => {
        if (reportPeriod === null || reportPeriod === '') {
            alertMessage = t('message.common.alert.period.select');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }

        if (reportSubway === null || reportSubway === '') {
            alertMessage = t('message.common.alert.subwayline.select');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }

        if (reportLevel1 === null || reportLevel1 === '') {
            alertMessage = t('message.common.alert.target.select');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }

        let params = reportPeriod.split(',');
        let reportPeriodParam = {code:params[0],title:params[1]};
        setReportPeriodParam(reportPeriodParam);
        
        params = reportSubway.split(',');
        let reportSubwayParam = {code:params[0],title:params[1]};
        setReportSubwayParam(reportSubwayParam);

        params = reportLevel1.split(',');
        let reportLevel1Param = {id:params[0],name:params[1]};
        setReportLevel1Param(reportLevel1Param);

        let year = reportPeriodParam.code.indexOf("cy") !== -1 ? curYear:curYear-1;
        let quarter = reportPeriodParam.code.replace("cy","").replace("oy","");
        
        let param = {"equipmentCtgrId":reportLevel1Param.id, "subwayLine":reportSubwayParam.code}
        param.year = year;
        if (quarter)
            param.quarter = quarter;

        let topHeader2s = [t('message.common.subtitle.level2'), t('message.common.subtitle.level3'), year+t('message.common.title.year')+(quarter?" "+quarter+t('message.common.select.quarter'):"")];
        if (quarter) {  // 분기 선택
            if (parseInt(quarter) === 1) {
                topHeader2s.push((year-1).toString().concat(t('message.common.title.year')," ","4"+t('message.common.select.quarter')));
            } else {
                topHeader2s.push((year).toString().concat(t('message.common.title.year')," ",(quarter-1),t('message.common.select.quarter')));
            }
            topHeader2s.push("");
            topHeader2s.push("");
            topHeader2s.push((year-1).toString().concat(t('message.common.title.year')," ",quarter,t('message.common.select.quarter')));
            topHeader2s.push("");
            topHeader2s.push("");
        } else {
            topHeader2s.push((year-1).toString().concat(t('message.common.title.year')));
            topHeader2s.push("");
            topHeader2s.push("");
            topHeader2s.push("");
            topHeader2s.push("");
            topHeader2s.push("");
        }
        setExcelTopHeader2s(topHeader2s);

        let topHeader22s = ["", "", ""];
        topHeader22s.push(t('message.common.subtitle.count'));
        topHeader22s.push(t('message.common.subtitle.increase.decrease.count'));
        topHeader22s.push(t('message.common.subtitle.increase.decrease.rate'));
        if (quarter) {  // 분기 선택
            topHeader22s.push(t('message.common.subtitle.count'));
            topHeader22s.push(t('message.common.subtitle.increase.decrease.count'));
            topHeader22s.push(t('message.common.subtitle.increase.decrease.rate'));
        } else {
            topHeader22s.push("");
            topHeader22s.push("");
            topHeader22s.push("");
        }
        setExcelTopHeader22s(topHeader22s);

        let topHeader3s = [t('message.common.subtitle.level2'), t('message.common.subtitle.level3'), t('message.common.select.component.part'), t('message.common.subtitle.position'), t('message.common.subtitle.total.count')];
        maintenanceTypes && maintenanceTypes.forEach(function(mType){
            topHeader3s.push(mType.title);
        })
        setExcelTopHeader3s(topHeader3s);

        let topHeader4s = [t('message.common.subtitle.level2'), t('message.common.subtitle.level3'), t('message.common.select.component.part'), t('message.common.subtitle.position'), t('message.common.subtitle.total.count')];
        maintenanceRecordTypes && maintenanceRecordTypes.forEach(function(mType){
            topHeader4s.push(mType.title);
        })
        setExcelTopHeader4s(topHeader4s);

        let topHeader5s = [t('message.common.subtitle.level2'), t('message.common.subtitle.level3'), t('message.common.select.component.part'), t('message.common.subtitle.manufacturer')];
        maintenanceTypes && maintenanceTypes.forEach(function(mType){
            topHeader5s.push(mType.title);
        })
        setExcelTopHeader5s(topHeader5s);

        let topHeader6s = [t('message.common.subtitle.level2'), t('message.common.subtitle.level3'), t('message.common.select.component.part'), t('message.common.subtitle.position'), t('message.common.subtitle.material')];
        maintenanceTypes && maintenanceTypes.forEach(function(mType){
            topHeader6s.push(mType.title);
        })
        setExcelTopHeader6s(topHeader6s);

        let title = year+t('message.common.title.year');
        if (quarter) {
            title += " "+quarter+t('message.common.select.quarter');
        }
        title += " " + reportSubwayParam.title;
        title += " " + reportLevel1Param.name;
        title += " " +t('message.common.title.maintenance.report');
        setReportTitle(title);

        Promise.all([
            //설비별 보고서(그래프)
            getReportCountMntTaskGroupByCtgr3ByQuery(param).then((data)=>{
                if(data && data.length > 0) {
                    let pieDatas = [];
                    let pieData = {};
                    data.forEach((element, i) =>{
                        pieData = {};
                        pieData.title = element[0];
                        pieData.cnt = element[1] ? element[1] : 0;
                        pieDatas.push(pieData);
                    })

                    let pieChartDatas = pieDatas;
                    if (pieDatas.length > 5) {
                        let copyStartPieDatas = pieDatas.slice(0,5);
                        let copyEndPieDatas = pieDatas.slice(5);

                        const sum = copyEndPieDatas.reduce((accumulator, currentValue) => {
                            return accumulator + currentValue[2]
                        }, 0);

                        copyStartPieDatas.push({title:t('message.common.subtitle.etc'), cnt:
                            copyEndPieDatas.reduce((accumulator, currentValue) => {
                                return accumulator + currentValue.cnt
                            }, 0)
                        })

                        pieChartDatas = copyStartPieDatas;
                    }
                    
                    setPieDatas(pieChartDatas);
                } else {
                    setPieDatas([]);
                }
            }),
            //  설비별 보고서(통계목록)
            getReportCountMntTaskGroupByCtgr23AndSubwayLineByQuery(param).then((data)=>{
                if(data && data.length > 0) {
                    setReports(data);

                    let excelDatas = [];
                    let excelData = [];
                    data && data.forEach(function(column, a) {
                        excelData = [];
                        let sum = column[2]+column[3];
                        excelTopHeaders.forEach(function(hd, b) {
                            let value = column[b];
                            if (b===2) {
                                value = sum;
                            } else if (b>2) {
                                value = column[b-1];
                            }
                            excelData.push(value);
                        })
                        excelDatas.push(excelData);
                    })
                    setExcelDatas(excelDatas);

                    let barDatas = [...excelDatas];
                    reverseOrderNumber(barDatas, 2)
                    let barChartDatas = barDatas;
                    console.log(barChartDatas)
                    if (barDatas.length > 5) {
                        let copyStartBarDatas = barDatas.slice(0,5);
                        let copyEndBarDatas = barDatas.slice(5);

                        // const sum = copyEndBarDatas.reduce((accumulator, currentValue) => {
                        //     return accumulator + currentValue[2]
                        // }, 0);

                        copyStartBarDatas.push([t('message.common.subtitle.etc'),t('message.common.subtitle.etc'),
                            copyEndBarDatas.reduce((accumulator, currentValue) => {
                                return accumulator + currentValue[2]
                            }, 0),
                            copyEndBarDatas.reduce((accumulator, currentValue) => {
                                return accumulator + currentValue[3]
                            }, 0),
                            copyEndBarDatas.reduce((accumulator, currentValue) => {
                                return accumulator + currentValue[4]
                            }, 0),
                            // copyEndBarDatas.reduce((accumulator, currentValue) => {
                            //     return accumulator + currentValue[5]
                            // }, 0)
                        ])

                        barChartDatas = copyStartBarDatas;
                    }
                    let series = [{name:t('message.common.subtitle.one.subwayline'),data:[]},{name:t('message.common.subtitle.two.subwayline'),data:[]},{name:t('message.common.subtitle.total.count'),data:[]}];
                    let categories = [];
                    barChartDatas && barChartDatas.forEach(function(column, a) {
                        series[0].data.push(column[3]);
                        series[1].data.push(column[4]);
                        // series[2].data.push(column[5]);
                        // series[3].data.push(column[2]);
                        series[2].data.push(column[2]);
                        categories.push(column[1]);
                    })
                    let barData = {series, categories};
                    setBarData(barData);

                } else {
                    setReports([]);
                    setExcelDatas([]);
                    setBarData(null);
                }
            }),
            // 설비별 보고서(구성부별 조치유형)
            getReportCountMntTaskGroupByCtgr234AndPositionAndMntTypeByQuery(param).then((data)=>{
                if(data) {
                    setReport3s(data);
                    let rows1 = [];
                    data && data.forEach(function(column, a) {
                        rows1.push({
                            "id" : a,
                            "level2" : column[0],
                            "level3" : column[1],
                            "level4" : column[2],
                            "location" : column[3],
                            "sum" : column[4]+column[5]+column[6]+column[7],
                            "type1" : column[4],
                            "type2" : column[5],
                            "type3" : column[6],
                            "type4" : column[7]
                        })
                    })
                    setRows1(rows1);

                    let excelDatas = [];
                    let excelData = [];
                    data && data.forEach(function(column, a) {
                        excelData = [];
                        let sum = column[4]+column[5]+column[6]+column[7];
                        topHeader3s.forEach((hd, b)=>{
                            let value = column[b];
                            if (b===4) {
                                value = sum;
                            } else if (b>4) {
                                value = column[b-1];
                            }
                            excelData.push(value);
                        })
                        excelDatas.push(excelData);
                    })
                    setExcelData3s(excelDatas);
                } else {
                    setReport3s([]);
                    setExcelData3s([]);
                }
            }),
            // 설비별 보고서(구성부별 장애유형)
            getReportCountMntTaskGroupByCtgr234AndPositionAndRecordTypeByQuery(param).then((data)=>{
                if(data) {
                    setReport4s(data);

                    let rows2 = [];
                    data && data.forEach(function(column, a) {
                        rows2.push({
                            "id" : a,
                            "level2" : column[0],
                            "level3" : column[1],
                            "level4" : column[2],
                            "location" : column[3],
                            "sum" : column[4]+column[5],
                            "type1" : column[4],
                            "type2" : column[5]
                        })
                    })
                    setRows2(rows2);

                    let excelDatas = [];
                    let excelData = [];
                    data && data.forEach(function(column, a) {
                        excelData = [];
                        let sum = column[4]+column[5];
                        topHeader4s.forEach(function(hd, b) {
                            let value = column[b];
                            if (b===4) {
                                value = sum;
                            } else if (b>4) {
                                value = column[b-1];
                            }
                            excelData.push(value);
                        })
                        excelDatas.push(excelData);
                    })
                    setExcelData4s(excelDatas);
                } else {
                    setReport4s([]);
                    setExcelData4s([]);
                }
            }),
            // 설비별 보고서(제조업체별 조치유형)
            getReportCountMntTaskGroupByCtgr234AndMfCpnyNmAndMntTypeByQuery(param).then((data)=>{
                if(data) {
                    setReport5s(data);

                    let rows3 = [];
                    data && data.forEach(function(column, a) {
                        rows3.push({
                            "id" : a,
                            "level2" : column[0],
                            "level3" : column[1],
                            "level4" : column[2],
                            "madeby" : column[3],
                            "type1" : column[4],
                            "type2" : column[5],
                            "type3" : column[6],
                            "type4" : column[7]
                        })
                    })
                    setRows3(rows3);

                    let excelDatas = [];
                    let excelData = [];
                    data && data.forEach(function(column, a) {
                        excelData = [];
                        topHeader5s.forEach((hd, b)=>{
                            let value = column[b];
                            excelData.push(value);
                        })
                        excelDatas.push(excelData);
                    })
                    setExcelData5s(excelDatas);
                } else {
                    setReport5s([]);
                    setExcelData5s([]);
                }
            }),
            // 설비별 보고서(자재별 조치유형)
            getReportCountMntTaskGroupByCtgr234AndEquipmentPartAndMntTypeByQuery(param).then((data)=>{
                if(data) {
                    setReport6s(data);

                    let rows4 = [];
                    data && data.forEach(function(column, a) {
                        rows4.push({
                            "id" : a,
                            "level2" : column[0],
                            "level3" : column[1],
                            "level4" : column[2],
                            "location" : column[3],
                            "part" : column[4],
                            "type1" : column[5],
                            "type2" : column[6],
                            "type3" : column[7],
                            "type4" : column[8]
                        })
                    })
                    // console.log(rows4)
                    setRows4(rows4);

                    let excelDatas = [];
                    let excelData = [];
                    data && data.forEach(function(column, a) {
                        excelData = [];
                        topHeader6s.forEach((hd, b)=>{
                            let value = column[b];
                            excelData.push(value);
                        })
                        excelDatas.push(excelData);
                    })
                    setExcelData6s(excelDatas);
                } else {
                    setReport6s([]);
                    setExcelData6s([]);
                }
            })
        ]).then(()=>{
            setFileName(t('message.common.file.name.maintenance.analysis.report')+"_"+year+t('message.common.title.year')+"_"+(quarter ? quarter+t('message.common.select.quarter')+"_":"")+reportSubwayParam.title+"_"+t('message.common.file.name.equipment.report')+"_"+t('message.common.file.name.statistics')+"_" + Date.now());
            setFileName2(t('message.common.file.name.maintenance.analysis.report')+"_"+year+t('message.common.title.year')+"_"+(quarter ? quarter+t('message.common.select.quarter')+"_":"")+reportSubwayParam.title+"_"+t('message.common.file.name.equipment.report')+"_"+t('message.common.file.name.increase.decrease')+"_" + Date.now());
            setFileName3(t('message.common.file.name.maintenance.analysis.report')+"_"+year+t('message.common.title.year')+"_"+(quarter ? quarter+t('message.common.select.quarter')+"_":"")+reportSubwayParam.title+"_"+t('message.common.file.name.equipment.report')+"_"+t('message.common.file.name.component.part')+"_"+t('message.common.subtitle.actionType')+"_" + Date.now());
            setFileName4(t('message.common.file.name.maintenance.analysis.report')+"_"+year+t('message.common.title.year')+"_"+(quarter ? quarter+t('message.common.select.quarter')+"_":"")+reportSubwayParam.title+"_"+t('message.common.file.name.equipment.report')+"_"+t('message.common.file.name.component.part')+"_"+t('message.common.file.name.disability.type')+"_" + Date.now());
            setFileName5(t('message.common.file.name.maintenance.analysis.report')+"_"+year+t('message.common.title.year')+"_"+(quarter ? quarter+t('message.common.select.quarter')+"_":"")+reportSubwayParam.title+"_"+t('message.common.file.name.equipment.report')+"_"+t('message.common.file.name.manufacturer')+"_"+t('message.common.file.name.disability.type')+"_" + Date.now());
            setFileName6(t('message.common.file.name.maintenance.analysis.report')+"_"+year+t('message.common.title.year')+"_"+(quarter ? quarter+t('message.common.select.quarter')+"_":"")+reportSubwayParam.title+"_"+t('message.common.file.name.equipment.report')+"_"+t('message.common.file.name.material')+"_"+t('message.common.file.name.disability.type')+"_" + Date.now());
            if (quarter) {  // 분기 선택한 경우
                getReportCountQuarterlyMntTaskGroupByCtgr23ForTwoYearsByQuery(param).then((data)=>{
                    if(data) {
                        let data2 = data && data.map(function(column, a) {
                            let val1 = column[3]+","+(column[2]-column[3]);
                            if ((column[2]-column[3]) !== 0 && column[2] !== 0) {
                                val1 += ","+((column[2]-column[3])/column[2]*100).toFixed(1)+"%";
                            } else {
                                val1 += ",";
                            }
                            column[3] = val1;
                            let val2 = column[4]+","+(column[2]-column[4]);
                            if ((column[2]-column[4]) !== 0 && column[2] !== 0) {
                                val2 += ","+((column[2]-column[4])/column[2]*100).toFixed(1)+"%";
                            } else {
                                val2 += ",";
                            }
                            column[4] = val2;
                            return column
                        })
                        let excelDatas = [];
                        let excelData = [];
                        data2 && data2.forEach(function(column, a) {
                            excelData = [];
                            topHeader2s.forEach(function(hd, b) {
                                if (b < topHeader2s.length-6) {
                                    excelData.push(column[b]);
                                } else {
                                    if (b === (topHeader2s.length-6) || b === (topHeader2s.length-5)) {
                                        let temp = column[b].split(",");
                                        temp && temp.forEach(function(d, ti) {
                                            excelData.push(d);
                                        })
                                    }
                                }
                            })
                            excelDatas.push(excelData);
                        })
                        setReport2s(data2);
                        setExcelData2s(excelDatas);
                    } else {
                        setReport2s([]);
                        setExcelData2s([]);
                    }
                })
            } else {    // 년도만 선택된 경우
                getReportCountYearlyMntTaskGroupByCtgr23ForTwoYearsByQuery(param).then((data)=>{
                    if(data) {
                       let data2 = data && data.map(function(column, a) {
                            let val1 = column[3]+","+(column[2]-column[3]);
                            if ((column[2]-column[3]) !== 0 && column[2] !== 0) {
                                val1 += ","+((column[2]-column[3])/column[2]*100).toFixed(1)+"%";
                            } else {
                                val1 += ",";
                            }

                            column[3] = val1;
                            
                            let val2 = ",,";
                            column[4] = val2;
                            return column
                        })
                        let excelDatas = [];
                        let excelData = [];
                        data2 && data2.forEach(function(column, a) {
                            excelData = [];
                            topHeader2s.forEach(function(hd, b) {
                                if (b < topHeader2s.length-6) {
                                    excelData.push(column[b]);
                                } else {
                                    if (b === (topHeader2s.length-6) || b === (topHeader2s.length-5)) {
                                        let temp = column[b].split(",");
                                        temp && temp.forEach(function(d, ti) {
                                            excelData.push(d);
                                        })
                                    }
                                }
                            })
                            excelDatas.push(excelData);
                        })
                        setReport2s(data2);
                        setExcelData2s(excelDatas);
                    } else {
                        setReport2s([]);
                        setExcelData2s([]);
                    }
                })
            }
            setIsLoading(true);
        })
    }

    return (
        <div style={{color:"#000"}}>
            <div>
                <Box sx={{ minWidth: 120 }}>
                    {reportPeriodParams && 
                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                        <CustomReportSelect
                            key={'period'}
                            label={t('message.common.select.period')}
                            name={'period'}
                            onChange={(e)=>{
                                setIsLoading(false);
                                setReportPeriod(e.target.value);
                            }}
                            list={reportPeriodParams}
                        />
                    </FormControl>
                    }
                    {subwayLines && 
                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                        <CustomReportSelect
                            key={'subwayLine'}
                            label={t('message.common.subtitle.subwayline')}
                            name={'subwayLine'}
                            onChange={(e)=>{
                                setIsLoading(false);
                                setReportSubway(e.target.value);
                            }}
                            list={subwayLines}
                        />
                    </FormControl>
                    }
                    {equipmentCategoryLevel1s && 
                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                        <CustomReportSelect2
                            key={'level1'}
                            label={t('message.common.select.target.setting')}
                            name={'level1'}
                            onChange={(e)=>{
                                setIsLoading(false);
                                setReportLevel1(e.target.value);
                            }}
                            list={equipmentCategoryLevel1s}
                        />
                    </FormControl>
                    }

                    <Link to={''}><Button variant="contained" style={{marginTop:"13px",padding:"5px 15px"}} onClick={selectParam}>{t('message.common.btn.report.generation')}</Button></Link>
                </Box>
            </div>

            { isLoading &&
            <div>
                <p className="report-dataroom-tit">
                    {reportTitle}
                </p>
                <div style={{display: "flex",justifyContent:"center"}}>
                    {pieDatas && pieDatas.length > 0 && <PieChart pieDatas={pieDatas} />}
                    {barData && <BarChart barData={barData} />}
                </div>

                <p className="report-dataroom-subtit"><span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;{t('message.common.title.maintenance.statistics')}</p>
                <TableContainer>
                    <Table sx={{ minWidth: 1000, borderTop:"2px solid #9b9b9b" }} aria-label="simple table" className="list_table">
                        <TableHead>
                            <TableRow>
                                <TableCell>{t('message.common.subtitle.level2')}</TableCell>
                                <TableCell>{t('message.common.subtitle.level3')}</TableCell>
                                <TableCell>{t('message.common.subtitle.total.count')}</TableCell>
                                <TableCell>{t('message.common.subtitle.one.subwayline')}</TableCell>
                                <TableCell>{t('message.common.subtitle.two.subwayline')}</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                        { reports && reports.map(function(item, i) {
                            let sum = item[2] + item[3];
                            return (
                            <TableRow key={i}>
                                <TableCell>{item[0]}</TableCell>
                                <TableCell>{item[1]}</TableCell>
                                <TableCell>{sum}</TableCell>
                                <TableCell>{item[2]}</TableCell>
                                <TableCell>{item[3]}</TableCell>
                            </TableRow>
                            )
                        })}
                        </TableBody>
                    </Table>
                </TableContainer>

                <br/>

                {(excelDatas && excelDatas.length > 0) ?
                <div className="report-dataroom-button">
                    <div></div>
                    <div className='no-print-page'>
                    <CommonExcelDownload excelDatas={excelDatas} excelHeader={excelTopHeaders} title={`${reportTitle} ${t('message.common.title.maintenance.statistics')}`} filename={`${fileName}.xlsx`} />
                    </div>
                </div>
                :
                (reports && reports.length > 0) ?
                <div className="report-dataroom-button">
                    <div></div>
                    <div className='no-print-page' style={{color:"#000"}}>
                        <Box sx={{ display: 'flex', color:"#000" }}>
                            {t('message.common.text.excel.downloading')}<CircularProgress size="1rem" />
                        </Box>
                    </div>
                </div>
                : ''
                }

                <p className="report-dataroom-subtit"><span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;{t('message.common.title.maintenance.increase.decrease')}</p>
                <TableContainer>
                    <Table sx={{ minWidth: 1000, borderTop:"2px solid #9b9b9b" }} aria-label="simple table" className="list_table">
                        <TableHead>
                            <TableRow>
                            {excelTopHeader2s && excelTopHeader2s.map(function(hd, b) {
                                if (b < (excelTopHeader2s.length-6)) {
                                    return (
                                <TableCell key={b} rowSpan={2}>{hd}</TableCell>
                                    )
                                } else if (b === (excelTopHeader2s.length-6) || b === (excelTopHeader2s.length-3)) {
                                    return (
                                <TableCell key={b} colSpan={3}>{hd}</TableCell>
                                    )
                                }
                            })}
                            </TableRow>
                            <TableRow>
                            {excelTopHeader22s && excelTopHeader22s.map(function(hd, b) {
                                if (b >= (excelTopHeader22s.length-6)) {
                                    return (
                                <TableCell key={b}>{hd}</TableCell>
                                    )
                                }
                            })}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                        { excelData2s && excelData2s.map(function(item, i) {
                            let color1 = "red2", color2 = "red2";
                            if (item[4].indexOf("-") !== -1) {
                                color1 = "blue";
                            }
                            if (item[7].indexOf("-") !== -1) {
                                color2 = "blue";
                            }
                            return (
                            <TableRow key={i}>
                                <TableCell>{item[0]}</TableCell>
                                <TableCell>{item[1]}</TableCell>
                                <TableCell>{item[2]}</TableCell>
                                <TableCell className={color1}>{item[3]}</TableCell>
                                <TableCell className={color1}>{item[4]}</TableCell>
                                <TableCell className={color1}>{item[5]}</TableCell>
                                <TableCell className={color2}>{item[6]}</TableCell>
                                <TableCell className={color2}>{item[7]}</TableCell>
                                <TableCell className={color2}>{item[8]}</TableCell>
                            </TableRow>
                            )
                        })}
                        </TableBody>
                    </Table>
                </TableContainer>

                {(excelData2s && excelData2s.length > 0) ?
                <div className="report-dataroom-button">
                    <div></div>
                    <div className='no-print-page'>
                    <InDecreaseExcelDownload excelDatas={excelData2s} excelHeader={excelTopHeader2s} excelHeader2={excelTopHeader22s} title={`${reportTitle} ${t('message.common.title.maintenance.increase.decrease')}`} filename={`${fileName2}.xlsx`} />
                    </div>
                </div>
                :
                (report2s && report2s.length > 0) ?
                <div className="report-dataroom-button">
                    <div></div>
                    <div className='no-print-page' style={{color:"#000"}}>
                        <Box sx={{ display: 'flex', color:"#000" }}>
                            {t('message.common.text.excel.downloading')}<CircularProgress size="1rem" />
                        </Box>
                    </div>
                </div>
                : ''
                }

                <br/>

                <p className="report-dataroom-subtit"><span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;{t('message.common.title.component.part.actionType')}</p>
                <Box id="tableDiv">
                    <DataGridPro
                        rows={rows1 && rows1 !== undefined ? rows1 : []}
                        columns={columns1}
                        disableColumnFilter
                        sx={{
                        "& .MuiDataGrid-footerContainer, & .MuiDataGrid-toolbarContainer": {
                            display: "none",
                        },
                        "& .MuiDataGrid-cell.statusReport" : {overflow:"unset !important"},
                        }}
                    />
                </Box>

                {(excelData3s && excelData3s.length > 0) ?
                <div className="report-dataroom-button">
                    <div></div>
                    <div className='no-print-page'>
                    <CommonExcelDownload excelDatas={excelData3s} excelHeader={excelTopHeader3s} title={`${reportTitle} ${t('message.common.title.component.part.actionType')}`} filename={`${fileName3}.xlsx`} />
                    </div>
                </div>
                :
                (report3s && report3s.length > 0) ?
                <div className="report-dataroom-button">
                    <div></div>
                    <div className='no-print-page' style={{color:"#000"}}>
                        <Box sx={{ display: 'flex', color:"#000" }}>
                            {t('message.common.text.excel.downloading')}<CircularProgress size="1rem" />
                        </Box>
                    </div>
                </div>
                : ''
                }
                
                <br/>

                <p className="report-dataroom-subtit"><span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;{t('message.common.title.component.part.disability.type')}</p>
                <Box id="tableDiv">
                    <DataGridPro
                        rows={rows2 && rows2 !== undefined ? rows2 : []}
                        columns={columns2}
                        disableColumnFilter
                        sx={{
                        "& .MuiDataGrid-footerContainer, & .MuiDataGrid-toolbarContainer": {
                            display: "none",
                        },
                        "& .MuiDataGrid-cell.statusReport" : {overflow:"unset !important"},
                        }}
                    />
                </Box>

                {(excelData4s && excelData4s.length > 0) ?
                <div className="report-dataroom-button">
                    <div></div>
                    <div className='no-print-page'>
                    <CommonExcelDownload excelDatas={excelData4s} excelHeader={excelTopHeader4s} title={`${reportTitle} ${t('message.common.title.component.part.disability.type')}`} filename={`${fileName4}.xlsx`} />
                    </div>
                </div>
                :
                (report4s && report4s.length > 0) ?
                <div className="report-dataroom-button">
                    <div></div>
                    <div className='no-print-page' style={{color:"#000"}}>
                        <Box sx={{ display: 'flex', color:"#000" }}>
                            {t('message.common.text.excel.downloading')}<CircularProgress size="1rem" />
                        </Box>
                    </div>
                </div>
                : ''
                }

                <br/>

                <p className="report-dataroom-subtit"><span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;{t('message.common.title.manufacturer.actionType')}</p>
                <Box id="tableDiv">
                    <DataGridPro
                        rows={rows3 && rows3 !== undefined ? rows3 : []}
                        columns={columns3}
                        disableColumnFilter
                        sx={{
                        "& .MuiDataGrid-footerContainer, & .MuiDataGrid-toolbarContainer": {
                            display: "none",
                        },
                        "& .MuiDataGrid-cell.statusReport" : {overflow:"unset !important"},
                        }}
                    />
                </Box>

                {(excelData5s && excelData5s.length > 0) ?
                <div className="report-dataroom-button">
                    <div></div>
                    <div className='no-print-page'>
                    <CommonExcelDownload excelDatas={excelData5s} excelHeader={excelTopHeader5s} title={`${reportTitle} ${t('message.common.title.manufacturer.actionType')}`} filename={`${fileName5}.xlsx`} />
                    </div>
                </div>
                :
                (report5s && report5s.length > 0) ?
                <div className="report-dataroom-button">
                    <div></div>
                    <div className='no-print-page' style={{color:"#000"}}>
                        <Box sx={{ display: 'flex', color:"#000" }}>
                            {t('message.common.text.excel.downloading')}<CircularProgress size="1rem" />
                        </Box>
                    </div>
                </div>
                : ''
                }

                <br/>

                <p className="report-dataroom-subtit"><span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;{t('message.common.title.material.actionType')}</p>
                <Box id="tableDiv">
                    <DataGridPro
                        rows={rows4 && rows4 !== undefined ? rows4 : []}
                        columns={columns4}
                        disableColumnFilter
                        sx={{
                        "& .MuiDataGrid-footerContainer, & .MuiDataGrid-toolbarContainer": {
                            display: "none",
                        },
                        "& .MuiDataGrid-cell.statusReport" : {overflow:"unset !important"},
                        }}
                    />
                </Box>

                {(excelData6s && excelData6s.length > 0) ?
                <div className="report-dataroom-button">
                    <div></div>
                    <div className='no-print-page'>
                        <CommonExcelDownload excelDatas={excelData6s} excelHeader={excelTopHeader6s} title={`${reportTitle} ${t('message.common.title.material.actionType')}`} filename={`${fileName6}.xlsx`} />
                    </div>
                </div>
                :
                (report6s && report6s.length > 0) ?
                <div className="report-dataroom-button">
                    <div></div>
                    <div className='no-print-page' style={{color:"#000"}}>
                        <Box sx={{ display: 'flex', color:"#000" }}>
                            {t('message.common.text.excel.downloading')}<CircularProgress size="1rem" />
                        </Box>
                    </div>
                </div>
                : ''
                }

            </div>
            }
        </div>
    )

}

export default EquipmentReportReportDataroomMaintenenceReport;